import React from 'react';
import PropTypes from 'prop-types';
import styles from './GeoHierarchyDescription.less';

export default function GeoHierarchyDescription({ locationName }) {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.container}>
      Wie entwickeln sich aktuell die Preise für Häuser und Wohnungen in {locationName}? Entdecken Sie hier die
      Immobilienpreise in {locationName} der letzten 4 Jahre und erfahren Sie, wie viel ein Quadratmeter im Jahr{' '}
      {currentYear} kostet.
    </div>
  );
}

GeoHierarchyDescription.propTypes = {
  locationName: PropTypes.string.isRequired,
};

GeoHierarchyDescription.defaultProps = {};
